import type { PricedPricing } from "~/lib/api";
import { formatPrice } from "~/lib/format";
import { cn } from "~/lib/utils";
import { formatPricePointLabel } from "./pricing/pricing-types";

interface PlacePricingProps {
  pricing: PricedPricing;
  className?: string;
}

export function PlacePricing({ pricing, className }: PlacePricingProps) {
  if (!pricing.prices.length) return null;

  return (
    <div className={cn("flex flex-col gap-1", className)}>
      {pricing.prices.map((price) => {
        const formatted = formatPrice(price.amount, pricing.currency);
        if (!formatted) return null;
        const displayLabel = formatPricePointLabel(price);
        return (
          <div
            key={`${price.type}-${price.label ?? ""}-${price.amount}`}
            className="flex items-baseline justify-between text-sm"
          >
            <span className="text-muted-foreground">{displayLabel}</span>
            <span className="font-medium tabular-nums">{formatted}</span>
          </div>
        );
      })}
    </div>
  );
}
